import { render, staticRenderFns } from "./batchform.vue?vue&type=template&id=aa147e6a&scoped=true&"
import script from "./batchform.vue?vue&type=script&lang=js&"
export * from "./batchform.vue?vue&type=script&lang=js&"
import style0 from "./batchform.vue?vue&type=style&index=0&id=aa147e6a&lang=scss&scoped=true&"
import style1 from "./batchform.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa147e6a",
  null
  
)

export default component.exports